<template>
  <div id="list-portal-model">
    <v-card>
      <v-card-title>
        Modèles de portail
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          icon
          @click.stop="createPortalModelDialog = true"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <create-portal-model-dialog
          :open.sync="createPortalModelDialog"
          v-if="createPortalModelDialog"
        ></create-portal-model-dialog>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="portalModels"
          :items-per-page="10"
          :loading="isLoading"
          @click:row="
            (item) =>
              $router.push({
                name: 'modeles-portails-details',
                params: { id: item.id },
              })
          "
          class="table-cursor"
        >
          <template v-slot:item.actions="{ item }">
            <v-btn small icon @click.stop="openEditDialog(item)">
              <v-icon>mdi-square-edit-outline</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <edit-portal-model-dialog
          :portal-model="editedItem"
          :open.sync="editPortalModelDialog"
          v-if="editPortalModelDialog"
        ></edit-portal-model-dialog>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { onMounted, toRefs, ref } from "@vue/composition-api";
import { usePortalModel } from "@/composables/portal-model";
import CreatePortalModelDialog from "@/components/PortalModel/CreatePortalModelDialog";
import EditPortalModelDialog from "@/components/PortalModel/EditPortalModelDialog";
import { useTitle } from "@/composables/title";

export default {
  components: {
    EditPortalModelDialog,
    CreatePortalModelDialog,
  },
  setup() {
    /* Import des API */
    const {
      portalModels,
      listPortalModels,
      portalModelData,
    } = usePortalModel();
    const { setTitle, setIcon } = useTitle();

    /* Variables */
    const editedItem = ref({});

    /* Méthodes */
    const openEditDialog = function (item) {
      editedItem.value = { ...item };
      portalModelData.editPortalModelDialog = true;
    };

    onMounted(() => {
      setTitle("Modèles de portails");
      setIcon("portal_model");
      listPortalModels();
    });

    return {
      ...toRefs(portalModelData),
      portalModels,
      headers: [
        { text: "Action", value: "actions" },
        { text: "Nom", value: "name" },
        { text: "Chemin", value: "url" },
      ],
      openEditDialog,
      editedItem,
    };
  },
};
</script>
<style scoped>
.activeRow {
  background-color: rgba(0, 255, 0, 0.2);
}
.notActiveRow {
  background-color: rgba(255, 0, 0, 0.2);
}
.table-cursor::v-deep tbody {
  cursor: pointer;
}
</style>
